import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { withInvestorScopeParams } from './investorScope';

// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  timeout: 10000
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore();
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`;
    }
    config.params = withInvestorScopeParams(
      config.url,
      config.method,
      config.params,
      authStore.selectedInvestorId
    );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return response;
    }

    const { data } = response;
    if (!data.success) {
      return Promise.reject(new Error(data.message || 'Request failed'));
    }
    return data;
  },
  (error) => {
    const { response } = error;
    
    if (response?.status === 401) {
      const authStore = useAuthStore();
      authStore.logout();
    }
    
    return Promise.reject(error);
  }
);

export default request;
